import SectionTypeImage from './image';
import SectionTypeText from './text';
import SectionTypeList from './list';
import SectionTypeInitialText from './initial-text';
import TypeSection from './TypeSection';

export {
  SectionTypeImage,
  SectionTypeText,
  SectionTypeList,
  SectionTypeInitialText,
  TypeSection
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/index.js